import React, { useState, useEffect } from "react";
import { Link } from "gatsby";
import Img from "gatsby-image";

import ReactMapboxGl, {
  Layer,
  Feature,
  ZoomControl,
  Popup,
} from "react-mapbox-gl";
import { LngLatBounds, LngLat } from "mapbox-gl";
import "mapbox-gl/src/css/mapbox-gl.css";

let Map = null;

const ResultsMap = ({ properties }) => {
  const [hasMounted, setHasMounted] = useState(false);
  const [expanded, setExpanded] = useState(null);

  useEffect(() => {
    setHasMounted(true);
  }, []);
  if (!hasMounted) {
    return null;
  }
  if (!Map) {
    Map = ReactMapboxGl({
      accessToken: process.env.GATSBY_MAPBOX_TOKEN,
      // minZoom: 6, //debugging
      maxZoom: 12,
      scrollZoom: false,
    });
  }
  const bounds = new LngLatBounds();
  const features = [];
  let popup = null;
  for (const property of properties) {
    // if (!property.property.gps_coordinates) {
    //   continue;
    // }
    const [lat, lon] = property.property.gps_coordinates.split(", ");
    bounds.extend(new LngLat(lon, lat));
    features.push(
      <Feature
        key={property.id}
        coordinates={[lon, lat]}
        onClick={() => {
          if (property.id !== expanded) {
            setExpanded(property.id);
          } else {
            setExpanded(null);
          }
        }}
      />
    );
    if (property.id === expanded) {
      popup = (
        <Popup
          coordinates={[lon, lat]}
          ahchor="bottom-left"
          offset={25}
          className=""
        >
          <div className="card border-0 shadow map-popup">
            <div className="card-img-top overflow-hidden">
              {property.fields ? (
                <Img
                  fluid={property.fields.first_picture.childImageSharp.fluid}
                  alt={property.property.marketing_name}
                  className="img-fluid"
                />
              ) : null}
              <Link to={property.url} className="tile-link"></Link>
            </div>
            <div className="card-body d-flex align-items-center">
              <div className="">
                <h6 className="card-title">
                  <Link
                    to={property.url}
                    className="text-dark font-weight-normal"
                  >
                    {property.property.marketing_name}
                  </Link>
                </h6>
                <div className="h6 d-flex card-subtitle font-weight-normal">
                  <p className="card-text flex-grow-1 mb-0 text-muted">
                    <span className="text-primary font-weight-bold">
                      €{property.property.starting_price}
                    </span>
                    &nbsp;/vko
                  </p>
                </div>
              </div>
            </div>
          </div>
        </Popup>
      );
    }
  }

  if (properties.length === 0) {
    const coordinates = [
      ["47.083333", "12.183333"],
      ["37.933333", "16.05"],
      ["45.1", "10.616667"],
      ["40.1", "10.516667"],
    ];
    for (let [lat, lon] of coordinates) {
      bounds.extend(new LngLat(lon, lat));
    }
  }

  return (
    <Map
      style="mapbox://styles/freiksenet/ck7ejv8wk2ei81iob3yexuywh"
      className="height-without-footer"
      containerStyle={{
        width: "100%",
      }}
      fitBounds={[
        bounds.getNorthWest().toArray(),
        bounds.getSouthEast().toArray(),
      ]}
      fitBoundsOptions={{ padding: 100 }}
      onClick={() => {
        setExpanded(null);
      }}
    >
      <ZoomControl position="top-left" style={{ marginTop: 10 }} />
      <Layer
        type="symbol"
        id="marker"
        layout={{
          "icon-image": "starmap50",
          "icon-size": 1,
          "icon-allow-overlap": true,
        }}
        minZoom={0}
      >
        {features}
      </Layer>
      {popup}
    </Map>
  );
};

export default ResultsMap;
